import React from 'react';

export interface FilterDisplayItem {
  label: string;
  value: string;
}

interface Props {
  filters: FilterDisplayItem[];
  onReset?: () => void;
}

export const SyutFilterSummaryBar: React.FC<Props> = ({ filters, onReset }) => {
  // Show all filters (even those set to "All") so users always see the full context
  const appliedFilters = filters.filter(f => f.value && f.value !== 'All');
  const hasFilters = appliedFilters.length > 0;

  return (
    <div className="syut-filter-summary-bar">
      <span style={{ fontWeight: 600, marginRight: '0.25rem', flexShrink: 0 }}>Filters:</span>
      {!hasFilters && (
        <span style={{ fontStyle: 'italic', color: 'var(--text-muted)' }}>No filters applied</span>
      )}
      {filters.map((f, i) => (
        <span key={i} className="filter-chip" style={f.value === 'All' ? { opacity: 0.5 } : undefined}>
          {f.label}: <span className="chip-label">{f.value}</span>
        </span>
      ))}
      {hasFilters && onReset && (
        <button className="filter-reset-btn" onClick={onReset} title="Clear all filters">
          Reset
        </button>
      )}
    </div>
  );
};

export default SyutFilterSummaryBar;
